export const isEmptyBillingInfoErrorResponse = (res: any) => {
    return (
        res?.status === 400 && ['NO_COUNTRY_SELECTED', 'NO_CURRENCY_SELECTED'].includes(res?.reason)
    );
};
